import { css } from '@emotion/react';
import { ITheme } from '../../services/style/type';

export const colorError = (themeProps: ITheme) => css`
  color: ${themeProps.colorsText.error} !important;
`;
